import { useConversationSidePanelContext } from "@app/components/assistant/conversation/ConversationSidePanelContext";
import {
  useCreateConversationLiveDoc,
  useLiveDocs,
} from "@app/lib/swr/live_docs";
import type { LightWorkspaceType } from "@app/types/user";
import { useCallback } from "react";

// Opens a conversation's one object of a kind in the side panel: its space (the desktop of its
// live objects) or its call. It is made on first open; agents make them as they need them.
export function useOpenConversationLiveDoc({
  owner,
  conversationId,
  kind,
  title,
}: {
  owner: LightWorkspaceType;
  conversationId: string | null;
  kind: "space" | "media";
  title: string;
}) {
  const { openPanel } = useConversationSidePanelContext();
  const { liveDocs } = useLiveDocs({ owner, disabled: !conversationId });
  const createLiveDoc = useCreateConversationLiveDoc({ owner });
  const existingId =
    liveDocs.find(
      (doc) => doc.conversationId === conversationId && doc.kind === kind
    )?.sId ?? null;

  return useCallback(async () => {
    if (!conversationId) {
      return;
    }
    const docId =
      existingId ?? (await createLiveDoc({ conversationId, kind, title }))?.sId;
    if (docId) {
      openPanel({ type: "live_doc", docId });
    }
  }, [existingId, createLiveDoc, conversationId, kind, title, openPanel]);
}
